function t() {
  var t = arguments,
    r = t.length - 1;
  return function () {
    for (var n = r, a = t[r].apply(this, arguments); n--;) a = t[n].call(this, a);
    return a;
  };
}
export { t as default };